import { AlertOctagon, ScanLine, FileWarning, MapPin, RotateCcw } from "lucide-react";
import { Button } from "@/components/ui/button";

const CONFIG = {
  new_car_detected: {
    Icon: AlertOctagon,
    accent: "text-warning",
    ring: "border-warning/30 bg-warning-soft",
    title: "New-car compliance is not yet supported",
    testId: "gate-new-car",
  },
  out_of_area: {
    Icon: MapPin,
    accent: "text-warning",
    ring: "border-warning/30 bg-warning-soft",
    title: "Support for more regions is coming soon",
    testId: "gate-out-of-area",
  },
  vin_missing: {
    Icon: ScanLine,
    accent: "text-destructive",
    ring: "border-destructive/30 bg-red-50",
    title: "We couldn't read the VIN",
    testId: "gate-vin-missing",
  },
  not_a_contract: {
    Icon: FileWarning,
    accent: "text-muted-foreground",
    ring: "border-border bg-secondary",
    title: "That doesn't look like a Bill of Sale",
    testId: "gate-not-contract",
  },
};

export const GateMessage = ({ result, onReset }) => {
  const cfg = CONFIG[result.status] || CONFIG.not_a_contract;
  const { Icon } = cfg;

  return (
    <div data-testid={cfg.testId} className="animate-fade-up rounded-xl border border-border bg-card p-8 sm:p-12">
      <div className={`mx-auto flex max-w-lg flex-col items-center rounded-xl border ${cfg.ring} p-8 text-center`}>
        <Icon className={`h-10 w-10 ${cfg.accent}`} aria-hidden="true" />
        <h2 className="mt-5 font-heading text-2xl font-800 tracking-tight text-foreground">{cfg.title}</h2>
        <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{result.message}</p>
        {result.condition_reasoning && (
          <p className="mt-3 font-mono-plex text-xs text-muted-foreground">Detected: {result.condition_reasoning}</p>
        )}
        <Button data-testid="gate-reset-btn" onClick={onReset} className="mt-7 rounded-full px-6">
          <RotateCcw className="mr-2 h-4 w-4" aria-hidden="true" /> Upload a different file
        </Button>
      </div>
    </div>
  );
};
